import { getUserEmail, getUserFullName } from "@faire/help-center-utils/serialized-data/getUser";
import { QueryParameters as EmailQueryParameters } from "@faire/web-api/routes/support/self-serve/email";
import { useStrictLocalization } from "@faire/web/common/localization";
import { useQueryParams } from "@faire/web/ui/hooks/useQueryParams";
import { useIssuePlaceholder } from "./useIssuePlaceholder";
import { useScrollToTopOnLoadEffect } from "./useScrollToTopEffect";
import { useSelectedOrderNumber } from "./useSelectedOrderNumber";
export var useInitializeEmailField = function useInitializeEmailField() {
  var userFullName = getUserFullName();
  var emailAddress = getUserEmail();
  var queryParams = useQueryParams(EmailQueryParameters.parse);
  var selectedOrderNumber = useSelectedOrderNumber();
  var issuePlaceholder = useIssuePlaceholder();
  useScrollToTopOnLoadEffect(10);
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var prefilledDescriptionMessage = strictLocalize({
    id: "wYBZgr",
    defaultMessage: "'{Pre-populated message}"
  }) + "\n" + strictLocalize({
    id: "uR09mK",
    defaultMessage: "My marketing tools and referral invites were suspended—can I restore access?"
  });
  var prefilledSubjectLineMessage = strictLocalize({
    id: "IuPgGV",
    defaultMessage: "Regaining access to marketing tools"
  });
  var emailUsInitial = {
    name: userFullName,
    email: emailAddress,
    subject: queryParams.contact_reason === "invites_suspended" ? prefilledSubjectLineMessage : issuePlaceholder,
    orderNumber: selectedOrderNumber,
    description: queryParams.contact_reason === "invites_suspended" ? prefilledDescriptionMessage : "",
    websiteUrl: ""
  };
  return {
    emailUsInitial: emailUsInitial
  };
};